import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Preloader from './Preloader.jsx';

export default function PreloaderGuard({ children }) {
  const location = useLocation();
  const [showPreloader, setShowPreloader] = useState(false);

  useEffect(() => {
    const shouldShow = ['/login', '/'].includes(location.pathname);
    if (shouldShow) {
      setShowPreloader(true);

      const timeout = setTimeout(() => {
        setShowPreloader(false);
      }, 2500); // match with Preloader's _hide() duration

      return () => clearTimeout(timeout);
    }
  }, [location.pathname]);

  if (showPreloader) {
    return <Preloader />;
  }

  return <>{children}</>;
}
